import { motion } from 'framer-motion'

import * as Styles from './Loader.style'

const Loader: React.VFC = (props) => {
    return (
        <Styles.Wrapper
            as={motion.div}
            key="loader-wrapper"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <Styles.Loader
                key="loader"
                as={motion.div}
                initial={{ width: '0px' }}
                animate={{ width: '100%' }}
                exit={{ width: '0%', transition: { duration: 0.5 } }}
                transition={{ duration: 2, ease: 'easeInOut' }}
            />
        </Styles.Wrapper>
    )
}

export default Loader
